module.exports = __webpack_public_path__ + "static/media/bernd-dittrich-yGGYZfzbqnQ-unsplash.f1423a0f.jpg";